module.exports = __webpack_public_path__ + "img/f2.fc8bb877.png";